import { useEffect, useRef, useState } from 'react';
import AppEdit from './AppEdit';
import WebUniversal, { WebUniversalProps } from '../../system/WebUniversal';
import { columnsheadId } from '../../universal/columnshead';
import { Button, Popover, Select, Space, Tooltip } from 'antd';
import dayjs from 'dayjs';
import fetchApi from '../../../utils/api/fetchApi';
import AntdNotification from '../../../utils/extend/AntdNotification';
import getList from '../../../utilsTsx/universal/getList';
import { LoggerTypes } from '../../../bmCommonLibrary/bmDeclareTypes';

const WebComponent = (props: any) => {
    const ref = useRef<any>(undefined);
    const apiId = 'app';

    useEffect(() => {
    }, []);

    //表头
    const columnsHead = [
        {
            title: '应用名',
            dataIndex: 'name'
        },
        {
            title: '描述',
            dataIndex: 'description',
            render: (val: any) => <Tooltip placement="topLeft" title={`${val.substring(0, 50)}......`}>{
                val ? (val.length >= 20 ? `${val.substring(0, 20)}......` : val) : ''
            }</Tooltip>
        }
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WebUniversalProps = {
        ...props,
        titleName: '应用',
        apiId,
        columns,
        editOptions: {
            Editor: AppEdit
        }
    };

    return (
        <>
            <WebUniversal {...extendProps} ref={ref} />
        </>
    )
}

export default WebComponent;
